import crimsonMarshalArt from "../../assets/alpha/cards/commanders/crimson-marshal.svg";
import azureStrategistArt from "../../assets/alpha/cards/commanders/azure-strategist.svg";
import type { AlphaDeckId } from "../alpha-session-controller";

export interface AlphaDeckPresentation {
  readonly deckId: AlphaDeckId;
  readonly displayName: string;
  readonly faction: "assault" | "balanced";
  readonly commanderName: string;
  readonly commanderStats: {
    readonly attack: number;
    readonly guard: number;
    readonly capacity: number;
  };
  readonly artUrl: string;
  readonly artAlt: string;
  readonly summary: string;
  readonly composition: string;
}

export const ALPHA_DECK_PRESENTATION: Readonly<Record<AlphaDeckId, AlphaDeckPresentation>> =
  Object.freeze({
    assault: {
      deckId: "assault",
      displayName: "Crimson Assault",
      faction: "assault",
      commanderName: "Crimson Marshal",
      commanderStats: { attack: 3, guard: 0, capacity: 3 },
      artUrl: crimsonMarshalArt,
      artAlt: "Crimson Marshal in red armour carrying a banner",
      summary: "A test-only Alpha deck led by a forceful Commander.",
      composition: "15 Lands · 3 Commanders · 22 Armies",
    },
    balanced: {
      deckId: "balanced",
      displayName: "Azure Balanced",
      faction: "balanced",
      commanderName: "Azure Strategist",
      commanderStats: { attack: 1, guard: 0, capacity: 3 },
      artUrl: azureStrategistArt,
      artAlt: "Azure Strategist with a command staff and campaign map",
      summary: "A test-only Alpha deck with an Azure command identity.",
      composition: "15 Lands · 3 Commanders · 22 Armies",
    },
  });
